import { Link } from "react-router-dom";
import { ArrowRight, FileCheck2 } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { QUALITY_SECTIONS, QUALITY_DOCS, IMAGES } from "../data/site";

const Quality = () => (
    <div data-testid="quality-page">
        <PageHero
            kicker="QUALITY"
            title="Verified at"
            accent="Every Stage"
            sub="Engineering checks, electrical testing and performance verification — built into every project."
            image={IMAGES.engineer}
            crumb="Quality"
        />
        <section className="bg-white py-20 md:py-24">
            <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <div className="grid gap-px bg-slate-200 md:grid-cols-2 lg:grid-cols-3">
                    {QUALITY_SECTIONS.map((q, i) => (
                        <Reveal key={q.title} delay={Math.min(i * 0.06, 0.4)}>
                            <div className={`h-full bg-white p-8 ${i === 0 ? "lg:col-span-2 lg:bg-brand-ink" : ""}`} data-testid={`quality-${q.title.toLowerCase().replace(/\s+/g, "-")}`}>
                                <p className={`font-mono text-[10px] tracking-[0.22em] ${i === 0 ? "text-brand-ember" : "text-slate-400"}`}>
                                    {String(i + 1).padStart(2, "0")}
                                </p>
                                <h2 className={`mt-3 font-display text-lg font-bold uppercase ${i === 0 ? "text-white" : "text-brand-charcoal"}`}>{q.title}</h2>
                                <p className={`mt-3 text-sm leading-relaxed ${i === 0 ? "text-slate-400" : "text-slate-500"}`}>{q.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-20 grid items-start gap-12 lg:grid-cols-2">
                    <Reveal>
                        <Kicker>QUALITY DOCUMENTATION</Kicker>
                        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-brand-charcoal">
                            Documented. Traceable. <span className="text-brand-red">Handed Over.</span>
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-slate-600">
                            Project documentation is prepared and handed over as applicable to the project scope.
                        </p>
                        <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                            {QUALITY_DOCS.map((d) => (
                                <li key={d} className="flex items-center gap-3 border border-slate-200 bg-brand-mist px-4 py-3.5 text-sm font-medium text-slate-700" data-testid={`quality-doc-${d.toLowerCase().replace(/\s+/g, "-")}`}>
                                    <FileCheck2 size={17} className="shrink-0 text-brand-red" /> {d}
                                </li>
                            ))}
                        </ul>
                        <p className="mt-5 font-mono text-[10px] tracking-[0.16em] text-slate-400 uppercase">As applicable to the project</p>
                    </Reveal>
                    <Reveal delay={0.12} className="relative">
                        <div className="absolute -right-4 -top-4 h-full w-full border-2 border-brand-red" />
                        <img src={IMAGES.wiring} alt="Electrical control panel testing and inspection" loading="lazy" className="relative h-[420px] w-full object-cover" />
                    </Reveal>
                </div>

                <Reveal delay={0.15}>
                    <div className="mt-16 flex flex-col items-start justify-between gap-6 bg-brand-ink p-8 sm:flex-row sm:items-center md:p-10">
                        <p className="font-display text-2xl font-extrabold uppercase text-white">
                            Quality questions? <span className="text-brand-ember">Ask our engineers.</span>
                        </p>
                        <Link to="/contact" data-testid="quality-contact-cta"
                            className="group flex shrink-0 items-center gap-3 bg-brand-red px-7 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-ember">
                            CONTACT US <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Quality;
